<template>
    <div class="container">
        <div class="content">
            <sub-title title="参编书籍"></sub-title>

            <div class="list">
                <div
                    class="item"
                    v-for="(item,index) in data"
                    :key="index"
                >
                    <div
                        class="block"
                        :style="{backgroundImage:'url('+item.img+')'}"
                    >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from './sub-title.vue';

export default {
    components: { SubTitle },
    data() {
        return {
            data: [
                {
                    img: '/static/images/about/b_01.png',
                },
                {
                    img: '/static/images/about/b_02.png',
                },
                {
                    img: '/static/images/about/b_03.png',
                },
                {
                    img: '/static/images/about/b_04.png',
                },
                {
                    img: '/static/images/about/b_05.png',
                },
                {
                    img: '/static/images/about/b_06.png',
                },
                {
                    img: '/static/images/about/b_07.png',
                },
                {
                    img: '/static/images/about/b_08.png',
                },
                {
                    img: '/static/images/about/b_09.png',
                },
                {
                    img: '/static/images/about/b_10.png',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.container {
    background-color: #f2f5fc !important;
    padding-bottom: 85px;
    padding-top: 67px;

    .list {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        .item {
            width: 18%;
            .block {
                margin-top: 50px;
                width: 186px;
                height: 244px;
            }
        }
    }
}
</style>
